/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { ContainerBox, Text } from '@jagex/design_runescape';
import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Routes } from '@common/routes';
import { LangURLParams } from '@common/routes/types';
import { Container, LinkButton } from '@components/common/primitives';
import { LogoContainer } from '@components/layouts';

const NotFoundPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const { lang } = useParams<LangURLParams>();

  return (
    <>
      <Helmet>
        <title>{`${t('general:errors:NOT_FOUND')} - ${t('general:meta:siteTitle')}`}</title>
      </Helmet>
      <ContainerBox>
        <Container sx={{ textAlign: 'center' }}>
          <LogoContainer />
          <Text sx={{ my: '1.25rem' }}>{t('general:notFound:headingMessage')}</Text>
          <Text sx={{ mb: '1.25rem' }}>{t('general:notFound:mainMessage')}</Text>
          <LinkButton href={Routes.Account.url({ lang })} variant="buttons.secondary">
            {t('general:notFound:backButton')}
          </LinkButton>
        </Container>
      </ContainerBox>
    </>
  );
};

export default NotFoundPage;
